import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ChevronDown } from "lucide-react";
import { fadeUp, slideLeft } from "animations/variants";
import StepDetails from "components/BookATable/StepDetails";
import StepBooking from "components/BookATable/StepBooking";
import Stepper from "components/BookATable/Stepper";
import StepSummary from "components/BookATable/StepSummary";

const BookATable = () => {
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, 150);
  }, []);

  const [step, setStep] = useState(1);
  const [selectedDate, setSelectedDate] = useState(new Date());

  const STEPS = {
    DATE: "date",
    SERVICE: "service",
  };

  const [activeStep, setActiveStep] = useState(STEPS.SERVICE);

  console.log({ activeStep });

  const [booking, setBooking] = useState({
    date: "",
    time: "",
    persons: 0,
    area: "",
  });

  const [details, setDetails] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    notes: "",
    specialRequests: [],
  });
  return (
    <section className="relative bg-white py-32 px-2 overflow-hidden">
      <div className="max-w-3xl mx-auto relative">
        {/* CLOSE */}
        {/* <button className="absolute -top-6 right-0 w-12 h-12 bg-darkbg text-neonYellow rounded-md flex items-center justify-center shadow-lg">
          <X size={18} />
        </button> */}
        {/* HEADER */}
        <div className="text-center mb-14">
          <motion.h2
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            className="text-2xl md:text-3xl font-heading text-neonYellow animate-neonFlicker my-6"
          >
            Table Reservations
          </motion.h2>

          {/* DIVIDER */}
          <motion.div
            variants={fadeUp}
            className="mt-6 flex items-center justify-center gap-4"
          >
            <div className="w-20 border-t border-dashed border-gray-300"></div>
            <span className="w-2 h-2 bg-neonYellow rounded-full"></span>
            <div className="w-20 border-t border-dashed border-gray-300"></div>
          </motion.div>
        </div>
        <Stepper
          currentStep={step}
          selectedDate={selectedDate}
          booking={booking}
        />
        <AnimatePresence mode="wait">
          {step === 1 && (
            <motion.div
              key="step1"
              variants={slideLeft}
              initial="hidden"
              animate="show"
              exit="hidden"
            >
              <StepBooking
                booking={booking}
                setBooking={setBooking}
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                onNext={() => setStep(2)}
                activeStep={activeStep}
                setActiveStep={setActiveStep}
                steps={STEPS}
              />
            </motion.div>
          )}

          {step === 2 && (
            <motion.div
              key="step2"
              variants={slideLeft}
              initial="hidden"
              animate="show"
              exit="hidden"
            >
              <StepDetails
                details={details}
                setDetails={setDetails}
                onBack={() => setStep(1)}
                onNext={() => setStep(3)}
              />
            </motion.div>
          )}

          {step === 3 && (
            <motion.div
              key="step3"
              variants={slideLeft}
              initial="hidden"
              animate="show"
              exit="hidden"
            >
              <StepSummary
                booking={booking}
                details={details}
                onBack={() => setStep(2)}
                selectedDate={selectedDate}
              />
            </motion.div>
          )}
        </AnimatePresence>

        {/* STEP ACTIONS – shared */}
        <motion.div
          variants={fadeUp}
          initial="hidden"
          animate="show"
          className="hidden lg:flex flex-1 justify-end items-center mt-12 gap-y-6"
        >
          {/* BACK */}
          {step > 1 ? (
            <button
              onClick={() => setStep(step - 1)}
              className="px-8 py-3 hover:border hover:border-gray-300 rounded-md text-sm text-textGray tracking-wide"
            >
              Back
            </button>
          ) : (
            <div /> // keeps spacing
          )}

          {/* NEXT / SUBMIT */}
          {step < 3 ? (
            <button
              onClick={() => setStep(step + 1)}
              className="ml-4 px-8 py-3 bg-darkbg text-neonYellow rounded-md shadow hover:bg-neonYellow hover:text-navy"
            >
              Next
            </button>
          ) : (
            <button className="ml-4 px-8 py-3 bg-darkbg text-neonYellow font-medium rounded-md shadow hover:bg-neonYellow hover:text-navy">
              Book Table
            </button>
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default BookATable;
